export class GetFindingExclusionResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "findingExclusion",
            "baseName": "findingExclusion",
            "type": "FindingExclusion",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetFindingExclusionResponse.attributeTypeMap;
    }
    constructor() {
    }
}
